import { z } from 'zod'

/**
 * A freight category from `GET /api/v1/cargo/products`. `weightRequired` and
 * `dimensionsRequired` say which measurements a row carrying this category has to give.
 */
export type Product = {
  code: string
  title: string
  weightRequired: boolean
  dimensionsRequired: boolean
}

const productSchema = z.object({
  code: z.string().trim().min(1),
  title: z.string().trim().min(1),
  weightRequired: z.boolean(),
  dimensionsRequired: z.boolean(),
})

export function parseProducts(value: unknown): Product[] {
  const parsed = z.array(productSchema).min(1).safeParse(value)
  if (!parsed.success) throw new Error('Invalid product catalogue')
  const codes = parsed.data.map((product) => product.code)
  if (new Set(codes).size !== codes.length) throw new Error('Duplicate product codes')
  return parsed.data
}

/** Rows store the code; the read-only row and the chosen field show the title. */
export const productTitle = (code: string, products: readonly Product[]) =>
  products.find((product) => product.code === code)?.title ?? code
